import React from "react";

import Footer from 'components/home_footer'
// import Middle from "components/Cards";
import About from "components/about";
import styles from './about_page.module.css'

import second from 'static/second.jpg'

import Nabar from "components/Nabar";
import MainSearch from "components/main_search";

const AboutPage = () => {

  
  return ( 
    <div>
      <Nabar/>
      <div className='hero-banner magic-ball home'>
        <div className='main-banner'>
          <img src={second} alt='front pic' />
          <MainSearch banner={true}/>
        </div>
      </div>

        <About/>

      <div className={styles.footer}>
          <Footer/>
      </div> 
    </div>
  );
}

export default AboutPage;